import toast from 'react-hot-toast';

class Toaster {
	success(message: string) {
		toast.success(message, {
			duration: 3000,
			style: {
				fontSize: '1.25rem'
			}
		});
	}

	error(message: string) {
		toast.error(message, {
			duration: 3000,
			style: {
				fontSize: '1.25rem'
			}
		});
	}
}

export const toaster = new Toaster();